import React from 'react';
import { BaseMultiSelect, BaseSelect } from 'shared/inputs';
import { FormMultiSelect, FormSelect } from 'shared/formControls';
import { useGetMarkets } from 'src/fetch/markets';

const TerminalDropdown = (props) => {
  const { data: options } = useGetMarkets();

  const Component = props?.multiSelect
    ? (props?.useFormComponents ? FormMultiSelect : BaseMultiSelect)
    : (props?.useFormComponents ? FormSelect : BaseSelect);

  return !!options && <Component data={options} textField='name' keysOnly keyOnly {...props} />;
};

export default TerminalDropdown;
